import React, { FC } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch, Action } from 'redux'
import { createStructuredSelector } from 'reselect'

import SlaSelector from '../components/SlaSelector'
import { actionCreators } from '../actions'
import {
  shippingSelector,
  locationLogisticsInfoSelector,
  mapPackagesBySlaSelector,
} from '../selectors'
import { orderFormSelector } from '@/checkout-instore-legacy/order/selectors'
import useNetwork from '@/checkout-instore-legacy/hooks/useNetwork'

const SlaSelectorContainer: FC = (props) => {
  const slaProps = {
    ...props,
    isOnline: useNetwork(),
  }

  return <SlaSelector {...slaProps} />
}

export const mapStateToPropsSelector = createStructuredSelector({
  shipping: shippingSelector,
  locationLogisticsInfo: locationLogisticsInfoSelector,
  orderForm: orderFormSelector,
  packages: mapPackagesBySlaSelector,
})

const mapDispatchToProps = (dispatch: Dispatch<Action>) =>
  bindActionCreators(actionCreators, dispatch)

export default connect(
  mapStateToPropsSelector,
  mapDispatchToProps
)(SlaSelectorContainer)
